import { Button, Col, Row } from 'antd';
import React from 'react';
import { SavePreferencesProps } from './types';

const SavePreferences = ({
  onCancelChange,
  onSaveChanges,
  isFulfilled,
  isUpdated,
  savingChanges,
}: SavePreferencesProps): JSX.Element => {
  return (
    <Row gutter={32}>
      <Col>
        <Button
          disabled={!(isUpdated && isFulfilled) || savingChanges}
          type="primary"
          onClick={onSaveChanges}
        >
          Save changes
        </Button>
      </Col>
      {isUpdated && !savingChanges && (
        <Col>
          <Button
            disabled={!(isUpdated && isFulfilled) || savingChanges}
            type="ghost"
            onClick={() => onCancelChange()}
          >
            Cancel changes
          </Button>
        </Col>
      )}
    </Row>
  );
};
export default SavePreferences;
